export default __webpack_public_path__ + "static/media/replay.06c04618.svg";